import styled from 'styled-components';
import bundleBackground from '../../../../images/Oval.svg';

const ContainerStyled = styled.div`
  text-align: center;
  margin: auto;

  .swiper-container {
    overflow: visible;
  }

  .swiper-pagination {
    position: absolute;
    bottom: -10px;
  }

  .swiper-pagination-bullet-active {
    background: #e62771;
  }
`;

const SlideContainerStyled = styled.div`
  text-align: center;
  margin: auto;
  font-size: 16px;
  color: #381451;

  strong {
    font-weight: 600;
  }

  div {
    position: absolute;
    bottom: -70px;
    right: 0;
    left: 0;
  }

  section {
    display: block;
    padding: 80px 0px 5px;
    margin: 20px auto;
    width: 310px;
  }
  svg {
    margin-bottom: 60px;
  }
  p {
    display: block;
    line-height: 20px;
    margin: 17px 5px;
    height: 80px;
  }
`;

const HeaderStyled = styled.div`
  background: #2d1540;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 20px 25px 0;
  height: auto;
`;

const HeaderOvalStyled = styled.div`
  height: 25px;
  width: 100%;
  background-image: url(${bundleBackground});
  background-size: cover;
  background-position-y: bottom;
  background-position-x: center;
  top: 0;
  position: relative;
  z-index: 1;
`;

const SkipButtonStyled = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-decoration-line: underline;
  color: #4d008c;
  cursor: pointer;
  position: absolute;
  margin-top: 25px;
  align-self: center;
  display: flex;
  justify-content: center;
  width: 100%;
`;

export {
  HeaderStyled,
  HeaderOvalStyled,
  SlideContainerStyled,
  ContainerStyled,
  SkipButtonStyled,
};
